import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=c1617df0&scoped=true&"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementCard.vue?vue&type=style&index=0&id=c1617df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1617df0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow,VSpacer})
